import { Gauge } from "@phosphor-icons/react";

export function GaugeIcon({ size = 18, className = "text-[#1E3F33]" }) {
  return <Gauge size={size} weight="duotone" className={className} />;
}
